import { render } from "./HomeCategory.vue?vue&type=template&id=034bed70&scoped=true"
import script from "./HomeCategory.vue?vue&type=script&lang=js"
export * from "./HomeCategory.vue?vue&type=script&lang=js"

import "./HomeCategory.vue?vue&type=style&index=0&id=034bed70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034bed70"]])

export default __exports__